import React from 'react';
import { useQuery } from '@tanstack/react-query';
import api, { API_ENDPOINTS } from '../config/api';
import BlogPreviewCard from './BlogPreviewCard';
import { Loader2 } from 'lucide-react';

const BlogSidebar = ({ excludeId, category }) => {
  const { data, isLoading } = useQuery({
    queryKey: ['blogs', 'sidebar', category, excludeId],
    queryFn: async () => {
      const response = await api.get(API_ENDPOINTS.BLOGS.LIST, {
        params: { category, limit: 10 },
      });
      return response.data;
    },
    enabled: !!category,
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Loader2 className="w-6 h-6 animate-spin text-accent" />
      </div>
    );
  }

  const blogs = (data?.blogs || []).filter((b) => b._id !== excludeId).slice(0, 10);

  if (blogs.length === 0) return null;

  return (
    <aside className="w-full lg:w-80 space-y-6">
      <div className="card p-6">
        <h3 className="text-xl font-heading font-bold text-heading dark:text-white mb-4">
          More Stories
        </h3>
        <div className="space-y-0">
          {blogs.map((blog) => (
            <BlogPreviewCard key={blog._id} blog={blog} hideDescription={true} />
          ))}
        </div>
      </div>
    </aside>
  );
};

export default BlogSidebar;
